import React from 'react';

const Close = () => (
  <button
    className="close"
    id="nav-toggle"
    aria-label="toggle-navigation"
    >
     <i className="fa fa-times" aria-hidden="true"></i>
  </button>
);

export default Close;
